import { SuccessorBorrowersNestedList } from './SuccessorBorrowersNestedList';

export default SuccessorBorrowersNestedList;
